<template>
  <div class="w-100 my-5">
    <div class="row my-5" v-if="eventList">
      <div class="col-sm-12" v-for="(item, index) in eventList" :key="(item, index)">
        <v-card class="my-2 box-white d-flex flex-column">
          <div class="m-2 row">
            <span class="col-sm-3">{{ item.eventId }}</span>
            <span class="col-sm-4">{{ item.name }}</span>
            <span class="col-sm-3">{{ getDecimalFormat(item.drinkSoldQuantity || 0) }}&nbsp;/&nbsp;{{ getDecimalFormat(item.drinkTotalQuantity || 0) }}</span>
            <v-btn class="ml-auto mr-5 button-normal" small @click="getDrinkListTask(index)">
              <span>Set Sold/Total Quantity</span>
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t('please_wait') }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { firestore, functions } from '../../../main';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { showLoading, getDecimalFormat } from '../../../functions';

export default {
  name: 'SetDrinkSoldTotalQuantity',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    eventList() {
      return this.$store.state.eventList;
    }
  },
  mounted() {
    if (window.location.hostname !== 'localhost') {
      this.$router.push('/');
    }
  },
  methods: {
    getDecimalFormat,
    getDrinkListTask(index) {
      if (index < 0 || index >= this.eventList.length) {
        alert('finish');
        return;
      }
      const eventInfo = this.eventList[index];
      if (!eventInfo) {
        this.$toast.error('unknown error');
        return;
      }
      const loader = showLoading(this);
      let q;
      if (eventInfo.tag) {
        q = query(collection(firestore, 'drink'), where('eventId', '==', eventInfo.eventId), where('tag', '==', eventInfo.tag), where('deletedAt', '==', null));
      } else {
        q = query(collection(firestore, 'drink'), where('eventId', '==', eventInfo.eventId), where('deletedAt', '==', null));
      }
      getDocs(q).then(querySnapshot => {
        loader.hide();
        var drinkSoldQuantity = 0;
        var drinkTotalQuantity = 0;
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (data.category !== 'Longdrinks') {
            drinkSoldQuantity += data.soldQuantity || 0;
            drinkTotalQuantity += data.totalQuantity || 0;
          }
        });
        const origSoldQuantity = eventInfo.drinkSoldQuantity || 0;
        const origTotalQuantity = eventInfo.drinkTotalQuantity || 0;
        if (origSoldQuantity === drinkSoldQuantity && origTotalQuantity === drinkTotalQuantity) {
          this.$toast.success('Correct');
          //console.log(`[${index + 1} / ${this.eventList.length}] [${eventInfo.eventId}], [${eventInfo.name}], Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${drinkSoldQuantity} / ${drinkTotalQuantity}]`);
          //this.$toast.success(`[${index + 1} / ${this.eventList.length}] [${eventInfo.eventId}], [${eventInfo.name}], Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${drinkSoldQuantity} / ${drinkTotalQuantity}]`);
        } else {
          //console.log(`[${index + 1} / ${this.eventList.length}] [${eventInfo.eventId}], [${eventInfo.name}], Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${drinkSoldQuantity} / ${drinkTotalQuantity}]`);
          if (confirm(`Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${drinkSoldQuantity} / ${drinkTotalQuantity}], Fix now?`)) {
            this.setSoldTotalQuantityTask(eventInfo.eventId, drinkSoldQuantity, drinkTotalQuantity);
          }
        }
        /*setTimeout(() => {
          this.getDrinkListTask(index + 1);
        }, 200);*/
      }).catch(error => {
        loader.hide();
        this.$toast.error('Unexpected error occurs - ' + error.message);
      });
    },
    setSoldTotalQuantityTask(eventId, drinkSoldQuantity, drinkTotalQuantity) {
      if (!eventId) {
        this.$toast.info('Invalid event ID.');
        return;
      }
      const params = {
        functionName: 'setDrinkSoldTotalQuantity',
        eventId: eventId,
        drinkSoldQuantity: drinkSoldQuantity,
        drinkTotalQuantity: drinkTotalQuantity
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>